<!--
 * @Description: 
 * @Date: 2025-06-27 13:31:53
-->

<template>
  <BaseForm
    ref="formRef"
    label-position="top"
    scrollToError
    :model="modelValue"
    :rules="formRules"
  >
    <div class="form-dialog__title">
      <h1>上传发票</h1>
    </div>
    <div class="form-dialog__content" style="display: block">
      <BaseFormItem label="发票照片" prop="imgList">
        <div>
          <BaseUpload
            v-if="!disabled"
            style="margin-bottom: 20px"
            autoUpload
            btnText="上传发票"
            tipText="只能上传jpg/png，且每份不超过50MB"
            :listType="null"
            :accept="['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG']"
            :limit="20"
            :limitSize="50"
            :multiple="false"
            :showFileList="false"
            :http-request="uploadApi"
            @change="onImgChange"
          ></BaseUpload>
          <div
            style="
              position: relative;
              display: flex;
              align-items: flex-end;
              margin-bottom: 30px;
            "
            v-for="(img, imgIndex) in modelValue.imgList"
            :key="img.invoicePic"
          >
            <BaseImage
              style="width: 200px; height: 120px"
              :src="img.invoicePic"
              :preview-src-list="[img.invoicePic]"
            />
            <div style="margin-left: 20px">
              <span>票面金额</span>
              <BaseInputNumber
                style="width: 240px; display: block"
                placeholder="请输入"
                :disabled="disabled"
                :controls="false"
                :precision="2"
                :min="0"
                :max="999999999"
                v-model="img.invoiceAmount"
              />
            </div>
            <div style="margin-left: 20px">
              <span>发票号码</span>
              <BaseInput
                style="width: 240px"
                :disabled="disabled"
                v-model="img.invoiceNo"
              />
            </div>
            <BaseIcon
              v-if="!disabled"
              size="18"
              color="#ED7067"
              style="
                cursor: pointer;
                position: absolute;
                right: -35px;
                bottom: 10px;
              "
              @click="onImgRemove(imgIndex)"
            >
              <DeleteFilled />
            </BaseIcon>
          </div>
        </div>
      </BaseFormItem>
      <BaseFormItem
        label="其他材料"
        prop="fileList"
        v-if="!disabled || modelValue.fileList.length"
      >
        <BaseUpload
          style="margin-bottom: 20px"
          listType="text"
          autoUpload
          showFileList
          btnText="添加文件"
          :tipText="
            disabled ? '' : '只能上传png/jpg/jpeg/pdf/bmp文件，且每份不超过50MB'
          "
          :accept="['.jpg', '.jpeg', '.png', '.pdf', '.bmp']"
          :limit="disabled ? 1 : 10"
          :limitSize="50"
          :multiple="false"
          :http-request="uploadApi"
          :disabled="disabled"
          :uploadBtnProps="{
            limitOverHide: true
          }"
          :keys="{ name: 'fileName', url: 'fileUrl' }"
          v-model:fileList="modelValue.fileList"
          @preview="onFilePreview"
        ></BaseUpload>
      </BaseFormItem>
    </div>
  </BaseForm>
</template>

<script lang="tsx" setup>
import { defineModel, withDefaults, defineProps, ref, defineExpose } from 'vue';
import {
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseImage,
  BaseUpload,
  BaseIcon,
  BaseInputNumber
} from 'xrk-components';
import { uploadApi } from '@data-source/common/apis';
import { IndustryDetailData } from '@V/invoice/src/data-source/types';
import { DeleteFilled } from '@element-plus/icons-vue';
import { useRecognition } from '@V/invoice/src/hooks';

withDefaults(
  defineProps<{
    disabled: boolean;
  }>(),
  {}
);

const modelValue = defineModel<IndustryDetailData>();
const formRef = ref(null);

const formRules = {
  imgList: [
    {
      required: true,
      trigger: 'change',
      validator: (rule, v, callback) => {
        if (!v?.length) {
          return callback(new Error('请上传发票'));
        }
        if (v.some(item => !item.invoicePic)) {
          return callback(new Error('发票上传失败，请重新上传'));
        }
        if (v.some(item => !item.invoiceNo || !item.invoiceAmount)) {
          return callback(new Error('请填写发票信息'));
        }
        callback();
      }
    }
  ],
  fileList: [
    {
      required: false,
      trigger: 'change',
      validator: (rule, v, callback) => {
        if (v.some(item => !item.fileUrl)) {
          return callback(new Error('材料上传失败，请重新上传'));
        }
        callback();
      }
    }
  ]
};

const onImgChange = async v => {
  const { response } = v;
  if (response && response.data.fileUrl) {
    const ocr = await useRecognition(response.data.fileUrl);
    modelValue.value.imgList.push({
      imgDetailId: null,
      invoicePic: response.data.fileUrl,
      ...ocr
    });
  }
  formRef.value.validate('imgList');
};
const onImgRemove = index => {
  modelValue.value.imgList.splice(index, 1);
  formRef.value.validate('imgList');
};
const onFilePreview = v => {
  window.open(v.url);
};

defineExpose({
  validate: (...args: any) => formRef.value?.validate(...args)
});
</script>
